import { useDataModelStore } from "./dataModel";
import { usePaginatedListStore } from "./paginatedList";
import VueApiQueryList from "@/models/lists/VueApiQueryList";
import User from "@/models/User";
import Journal from "@/models/journal/JournalClass";
import JournalEntry from "@/models/journal/JournalEntry";
import JournalEntryLike from "@/models/journal/JournalEntryLike";
import JournalTag from "@/models/journal/JournalTag";
import Seen from "@/models/journal/Seen";
import EntryComment from "@/models/journal/EntryComment";

const Classes = new VueApiQueryList(function(id, context) {
    switch(context){
        case "user": {
            if (!id) {
                throw new Error("no user");
            }

            let user = new User({ id: id });
            return new Journal().for(user);
        }
    }

    return new Journal();
});

const Entries = new VueApiQueryList(function(id, context) {

    if (!context) {
        throw new Error("no context");
    }

    switch(context){
        case "user": {
            if (!id) {
                throw new Error("no user");
            }

            let user = new User({ id: id });
            return new JournalEntry().for(user);
        }
        case "journal": {
            if (!id) {
                throw new Error("no journal");
            }

            let journal = new Journal({ id: id });
            return new JournalEntry().for(journal);
        }
        default:
            throw new Error("unknown context");
    }

}, new JournalEntry());


const Tags = new VueApiQueryList(function(journalId) {
    if (!journalId) {
        throw new Error("no journal");
    }

    let journal = new Journal({ id: journalId });
    return new JournalTag().for(journal);
});

const Comments = new VueApiQueryList(function(id, context) {
    if (!context) {
        throw new Error("no context");
    }

    switch(context){
        case "journal": {
            let journal = new Journal({ id: id });
            return new EntryComment().for(journal);
        }
        case "entry": {
            let entry = new JournalEntry({ id: id })
            return new EntryComment().for(entry);
        }
        default:
            throw new Error("unknown context");
    }
}, new EntryComment());

const SeenBy = new VueApiQueryList(function(id, context) {
    if (!context) {
        throw new Error("no context");
    }

    switch(context){
        case "entry": {
            let entry = new JournalEntry({ id: id })
            return new Seen().for(entry);
        }
        default:
            throw new Error("unknown context");
    }
});

const Likes = new VueApiQueryList(function(id, context) {
    if (!context) {
        throw new Error("no context");
    }

    switch(context){
        case "entry": {
            let entry = new JournalEntry({ id: id })
            return new JournalEntryLike().for(entry);
        }
        default:
            throw new Error("unknown context");
    }
});

export const useJournalClassStore = useDataModelStore('journalClass', Classes);
export const useJournalEntryStore = useDataModelStore('journalEntry', Entries);
export const useJournalTagStore = useDataModelStore('journalTag', Tags);
export const useJournalEntryCommentStore = useDataModelStore('journalEntryComment', Comments);
export const useJournalSeenStore = useDataModelStore('journalSeen', SeenBy);
export const useJournalLikeStore = useDataModelStore('journalLike', Likes);

export const useJournalClassesStore = usePaginatedListStore("journalClasses", useJournalClassStore);
